// extracted by mini-css-extract-plugin
export var link = "_r8-0";